import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=3cd00c07&scoped=true"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfiguration.vue?vue&type=style&index=0&id=3cd00c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd00c07",
  null
  
)

export default component.exports